import { Loader, ModalHeader, ModalNext, ModalBody} from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { useAciUtil } from 'ent-capability-hooks';

// import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import metadata from './AccountConfirmationPopup.metadata.json5';
import styles from './AccountConfirmationPopup.module.scss';
import accMessages from './AccountConfirmationPopup.messages';


function AccountConfirmationPopup(props) {
    const {
        accountDetails,
        currState,
        authHeader,
        history,
        isOpen,
        onResolve,
        onReject,
        onAfterClose
    } = props;
    const { addPaymentInstrumentsToAccount } = useAciUtil();
    // const [isOpen, setIsOpen] = useState(false);
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, setIsLoading] = useState(false);
    const [accountNumber, setAccountNumber] = useState('');

    // const translator = useTranslator();
    // const [accountData, setAccountData] = useState();
   
    const {accountNos} = accountDetails;

    useEffect(() => {
        // Entering the screen for the first time

    // setIsOpen(true);
       setIsLoading(true);
       setAccountNumber('');
       setIsLoading(false);

    }, []);

    const handleSelectAccount = ((value) =>{
        setAccountNumber(value);
    })

    const onClickOk = useCallback(() =>{
        
        if ( !_.isEmpty(accountNumber)){ 
                addPaymentInstrumentsToAccount({
                    payFrom: 'managePaymentMethods',
                    selectedAccountNumber: accountNumber,
                    identifier: accountNumber, 
                    method:  'PAYMENT_METHODS', 
                    useProfile: true,
                    currState,
                    authHeader,
                    // eslint-disable-next-line no-warning-comments
                    emailAddress: 'info@twia.org', // TODO replace with customer email address
                    history
                });
                onResolve();
        } 

        if (_.isEmpty(accountNumber)){
            onReject();
        }
        
    }, [accountNumber, addPaymentInstrumentsToAccount, authHeader, currState, history, onReject, onResolve]);
    

    const getAccountNumberValues = useCallback(() => {
        const accountsArray = accountNos.map(acc => ({
                code: acc,
                name: acc
            }));
            
        return accountsArray;
    }, [accountNos]);

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        accountNumbersId: {
            availableValues: getAccountNumberValues(),
            value: accountNumber
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onClickOk,
            handleSelectAccount
        },
        resolveClassNameMap: styles
    };

    return (
        <ModalNext 
            isOpen={isOpen}  onAfterClose={onAfterClose}>
            <ModalHeader title={accMessages.pleaseSelectAccount} />
            <ModalBody>
                <Loader loaded={!isLoading}>
                    <ViewModelForm
                        uiProps={metadata.componentContent}
                        model={accountDetails}
                        overrideProps={overrideProps}
                        classNameMap={resolvers.resolveClassNameMap}
                        callbackMap={resolvers.resolveCallbackMap}
                    />
                </Loader>
            </ModalBody>
        </ModalNext>
    )
}

AccountConfirmationPopup.propTypes = {

    isOpen: PropTypes.bool,
    onResolve: PropTypes.func,
    onReject: PropTypes.func,
    onAfterClose: PropTypes.func,
};

AccountConfirmationPopup.defaultProps = {
    onAfterClose: _.noop,
    isOpen: false,
    onResolve: _.noop,
    onReject: _.noop
};

export default AccountConfirmationPopup;
